import React, { useCallback, useMemo, useRef, useState } from 'react';
// import GoogleMapReact from "google-map-react";
import {
	GoogleMap,
	useJsApiLoader,
	// Marker as MarkerLibrary,
	// InfoWindow,
	OverlayView,
	OverlayViewF,
	TrafficLayer,
} from '@react-google-maps/api';
import Marker from './Marker';
import MarkerAddress from './MarkerAddress';
import MarkerShop from './MarkerShop';
import MarkerLabelled from './MarkerLabelled';

const mapContainerStyle = {
	width: '100%',
	height: '100%',
};

const StableOverlay = React.memo(({ marker, children }) => {
	const pos = useMemo(() => ({ lat: marker.lat, lng: marker.lng }), [marker.lat, marker.lng]);
	return (
		<OverlayViewF position={pos} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
			{children}
		</OverlayViewF>
	);
});

const MyMap = ({
	center,
	markers,
	onClick,
	defaultZoom = 8,
	big,
	shouldAnimateTo,
	traffic,
	// Show every marker's name permanently instead of one at a time on click.
	// Off everywhere in the app: the live map can carry dozens of pins, and this
	// only makes sense for a map of a handful of fixed points (the auto-assign
	// simulator). Drivers were never clickable there anyway — Marker is only
	// given `isOpen` through `big`, so clicking one did nothing at all.
	alwaysShowLabels,
}) => {
	const { isLoaded } = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: import.meta.env.VITE_API_KEY,
		// googleMapsApiKey: 'AIzaSyACpHQprPFevW6VEBzKLyV5-8sFvgIsfds',
	});

	const [openedMarker, setOpenedMarker] = useState(null);
	// const [map, setMap] = React.useState(null);

	const mapRef = useRef();

	const onLoad = useCallback(function callback(map) {
		// This is just an example of getting and using the map instance!!! don't just blindly copy!
		// const bounds = new window.google.maps.LatLngBounds(center);
		// map.fitBounds(bounds);

		mapRef.current = map;

		if (shouldAnimateTo) {
			setTimeout(() => {
				mapRef.current.panTo(shouldAnimateTo); // Thessaloniki for example
			}, 400);
		}
	}, []);

	const openMarker = id => {
		// console.log("will open marker", id, openedMarker);
		setOpenedMarker(id === openedMarker ? null : id);
	};
	if (!isLoaded) {
		return null;
	}

	return (
		<GoogleMap
			// style={{ width: "100%", height: "100%" }}
			mapContainerStyle={mapContainerStyle}
			// bootstrapURLKeys={{
			//   // AIzaSyCW8AiPAv52m2hz06OmnlIfMkVY0GyRwi8
			//   key: import.meta.env.VITE_API_KEY,
			//   language: "el",
			//   mapTypeId: "roadmap",
			//   // region: 'gr',
			//   // region: 'gr'
			// }}
			// defaultCenter={center}
			onLoad={onLoad}
			center={center}
			zoom={defaultZoom}
			// layerTypes={["TrafficLayer"]}
			// hoverDistance={20}
			// center={{ lat, lng }}
			onClick={e => onClick && onClick(e.latLng.lat(), e.latLng.lng())}
			options={{
				mapTypeControl: false,
				mapTypeId: 'roadmap',
				scrollwheel: true,
			}}
			// resetBoundsOnResize
			// yesIWantToUseGoogleMapApiInternals
			// onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
		>
			{/* {places} */}

			{traffic && <TrafficLayer />}

			{markers.map(m => (
				<StableOverlay key={m.id} marker={m}>
					{alwaysShowLabels ? (
						<MarkerLabelled name={m?.name} type={m.type} />
					) : m.type === 'order' ? (
						<MarkerAddress
							name={m?.name}
							color={m?.color}
							isOpen={m.id === openedMarker}
							onClick={e => {
								// e.stopPropagation();
								openMarker(m.id);
							}}
						/>
					) : m.type === 'shop' ? (
						<MarkerShop
							name={m?.name}
							isOpen={m.id === openedMarker}
							onClick={e => {
								e.stopPropagation();
								openMarker(m.id);
							}}
						/>
					) : (
						<Marker
							name={m?.name}
							relativeTime={m?.relativeTime}
							onClick={e => {
								e.stopPropagation();
								openMarker(m.id);
							}}
							big={big}
						/>
					)}
				</StableOverlay>
			))}
		</GoogleMap>
	);
};

// MyMap.defaultProps = {
//   center: [37.9988844, 23.735316],
//   zoom: 9,
// };

export default MyMap;
